import React from "react";
import { Spinner } from "react-bootstrap";

const Loader = () => (
  <div className="d-flex justify-content-center align-items-stretch" style={{ height: "90vh" }}>
    <div className="my-auto">
      <Spinner animation="border" role="status" variant="primary" />
    </div>
  </div>
);

export default Loader;
